import { createGlobalPaymentImmediate } from '@/api/tablet';
import { useMutation } from 'react-query';

const useCreateGlobalPaymentImmediate = (userId: string, tabletId: string) => {
  return useMutation({
    mutationFn: (paymentAmount: number) =>
      createGlobalPaymentImmediate(userId, tabletId, paymentAmount),
  });
};

export default useCreateGlobalPaymentImmediate;
